export default "__VITE_ASSET__ClrZURd9__"